import { writable } from "svelte/store"
import { attachConfigurationStorageToMPSChartStore, initMPSChartStore } from "../MPSChartStore.js";

export function initPSITableStore(initialValues) {
  const MPSChartStore = initMPSChartStore(initialValues)

  const AggregateMethod = writable(initialValues.AggregateMethod)
  const PSISortOrder = writable(initialValues.PSISortOrder)
  return {
    ...MPSChartStore,
    AggregateMethod,
    PSISortOrder,
  }
}

/**
 * load configuration from storage and set the store values accordingly.
 * also subscribe the store values to save them in the storage if they change.
 * @param psiTableStore
 * @param mpsConfigurationStorage
 * @returns {Promise<void>}
 */
export async function attachConfigurationStorageToPSITableStore(psiTableStore, mpsConfigurationStorage) {
  const MPSConfiguration = await mpsConfigurationStorage.getConfiguration()

  if (MPSConfiguration.psiTable?.aggregateMethod) {
    psiTableStore.AggregateMethod.set(MPSConfiguration.psiTable.aggregateMethod)
  }
  psiTableStore.AggregateMethod.subscribe(val => mpsConfigurationStorage.saveConfiguration({psiTable: {aggregateMethod: val}}))

  if (MPSConfiguration.psiTable?.psiSortOrder) {
    psiTableStore.PSISortOrder.set(MPSConfiguration.psiTable.psiSortOrder)
  }
  psiTableStore.PSISortOrder.subscribe(val => mpsConfigurationStorage.saveConfiguration({psiTable: {psiSortOrder: val}}))

  await attachConfigurationStorageToMPSChartStore(psiTableStore, "psiTable", mpsConfigurationStorage)
}
